import React, { useMemo, useRef } from "react";
import { Canvas, useFrame } from "@react-three/fiber";
import * as THREE from "three";

function GlassBox() {
  const group = useRef();
  const mouse = useRef({ x: 0, y: 0 });

  React.useEffect(() => {
    const onMove = (e) => {
      mouse.current.x = (e.clientX / window.innerWidth) * 2 - 1;
      mouse.current.y = (e.clientY / window.innerHeight) * 2 - 1;
    };
    window.addEventListener("mousemove", onMove);
    return () => window.removeEventListener("mousemove", onMove);
  }, []);

  const w = 1.7,
    h = 2.8,
    d = 1.7;
  const geom = useMemo(() => new THREE.BoxGeometry(w, h, d), []);

  useFrame((state, delta) => {
    const g = group.current;
    if (!g) return;
    g.rotation.y += delta * 0.28;
    const targetX = mouse.current.y * 0.35 + 0.1;
    const targetZ = mouse.current.x * 0.25;
    g.rotation.x += (targetX - g.rotation.x) * 0.04;
    g.rotation.z += (targetZ - g.rotation.z) * 0.04;
    g.position.y = Math.sin(state.clock.elapsedTime * 0.6) * 0.14;
  });

  return (
    <group ref={group} rotation={[0.1, 0.4, 0]}>
      <mesh geometry={geom}>
        <meshStandardMaterial
          color={"#2c2c2c"}
          metalness={0.3}
          roughness={0.48}
          transparent
          opacity={0.72}
          envMapIntensity={0.6}
        />
      </mesh>
      <lineSegments geometry={geom}>
        <edgesGeometry args={[geom]} />
        <lineBasicMaterial color={"#ffffff"} transparent opacity={0.52} />
      </lineSegments>
      <lineSegments scale={1.45}>
        <edgesGeometry args={[geom]} />
        <lineBasicMaterial color={"#ffffff"} transparent opacity={0.12} />
      </lineSegments>
    </group>
  );
}

export default function ThreeScene() {
  return (
    <Canvas
      dpr={[1, 2]}
      camera={{ position: [0, 0, 7], fov: 40 }}
      gl={{ alpha: true, antialias: true }}
      style={{ background: "transparent" }}
    >
      <ambientLight intensity={0.22} />
      <directionalLight position={[5, 6, 5]} intensity={0.8} color={"#8d8578"} />
      <directionalLight position={[-6, -1, 3]} intensity={0.38} color={"#4d4a43"} />
      <pointLight position={[2, -3, 5]} intensity={1.2} color={"#b4aa98"} />
      <GlassBox />
    </Canvas>
  );
}
